import { render, staticRenderFns } from "./card-client.vue?vue&type=template&id=08d9ba12"
import script from "./card-client.vue?vue&type=script&lang=ts"
export * from "./card-client.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports